import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
import { useDirectedVideoContext } from '../DirectedVideoContext';
import { HowItWasMade } from '../howMade/HowItWasMade';
import { directedMessages as messages } from '../messages/directedMessages';
import { CastStep } from '../steps/CastStep';
import { FailedStep } from '../steps/FailedStep';
import { PriceStep } from '../steps/PriceStep';
import { ProgressStep } from '../steps/ProgressStep';
import { ScriptStep } from '../steps/ScriptStep';
import { StoriesStep } from '../steps/StoriesStep';
import { StyleStep } from '../steps/StyleStep';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The step on view (design b to g): one component per screen. */
const DirectedStepBodyComponent: React.FC = () => {
  const intl = useIntl();
  const { screen, leave, isMadeView } = useDirectedVideoContext();
  if (isMadeView) {
    return <HowItWasMade />;
  }
  switch (screen) {
    case 'cast':
      return <CastStep />;
    case 'stories':
      return <StoriesStep />;
    case 'style':
      return <StyleStep />;
    case 'script':
      return <ScriptStep />;
    case 'price':
      return <PriceStep />;
    case 'progress':
      return <ProgressStep />;
    case 'failed':
      return <FailedStep />;
    case 'cancelled':
    default:
      return (
        <div className={styles.fullState} data-testid="directed-video-cancelled">
          <h2 className={styles.fullStateTitle}>{intl.formatMessage(messages.cancelledTitle)}</h2>
          <p className={styles.fullStateText}>{intl.formatMessage(messages.cancelledText)}</p>
          <SMLButton onClick={leave}>{intl.formatMessage(messages.backToSong)}</SMLButton>
        </div>
      );
  }
};

export const DirectedStepBody = TypedMemo(DirectedStepBodyComponent);
